var slideIndex = 1;


// prova modali
function openModal() {
  document.getElementById("myModal").style.display = "flex";
}

function closeModal() {
  document.getElementById("myModal").style.display = "none";
}
function plusSlides(n) {
  showSlides(slideIndex += n);
}


function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var captionText = document.getElementById("caption");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  if(slides[slideIndex-1] != undefined){
    slides[slideIndex-1].style.display = "flex";
  }
}

window.onload = function() {
  showSlides(slideIndex);
};




jQuery(function($) {
  $('.rassegna-slider').slick({
    dots: true,
    infinite: true,
    variableWidth: true,
    slidesToShow: 3,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $('.is_slider').slick({
    infinite: true,
    slidesToShow: 1.5,
    centerMode: true,
    autoplaySpeed: 5000,
  });
});


jQuery(function($) {
  $('.catalogSlider-slider').slick({
    dots: true,
    infinite: true,
    variableWidth: true,
    slidesToShow: 1,
    prevArrow: false,
    nextArrow: false
  });
});



var slideCount = $('.slideCount');
 var slickSlide = $('.aboutSlider-slider');

 slickSlide.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
   var i = (currentSlide ? currentSlide : 0) + 1;
   slideCount.html('<span class="slideCountItem">' + i + '</span> ' + '/' + ' <span class="slideCountAll">' + slick.slideCount + '</span>');
 });



jQuery(function($) {
  $('.aboutSlider-slider').slick({
    dots: false,
     infinite: true,
     speed: 300,
     autoplay: true,
     slidesToShow: 1,
     adaptiveHeight: true,
     accessibility:false
  });
  AOS.refresh();
});


$( document ).ready(function() {
  let caso = document.querySelector(".case-image-text");
  let link = document.querySelector("#progetti");
  if(caso != undefined){
    link.style.setProperty('color', '#ac001b', 'important');
  }
});
